import { clsModel, fnCreate } from '@cls/clsModel'
import { employees as api } from '@/app/api'
import string from '@lib/string'
import Constants from '@app/consts'

var modelName = "employee";
const id_optimit_type = Constants.optimit_types.employee; 
const fields = ["id", "id_jobtitle", "id_department", "id_relation", "empl_gen_hourlist", "start_time_minutes", 
                "end_time_minutes", "empl_is_plannable", "empl_workweek_minutes", "firstname", "lastname", 
                "birthday", "email", "mobile", "bsn", "adr_street", "adr_street_number", "adr_zipcode", "adr_city", 
                "country_code", 
                "can_app_login",
                "can_app_hours",
                "can_app_workorders",
                "can_app_workorders_create",
                "hours_manage_employees",
                "hours_employees", 
                "workorders_create_for",
                "workorders_employees", 
                "acceptedUser",
                "invitedUser",
                "start_time_minutes_mon",
                "start_time_minutes_tue",
                "start_time_minutes_wed",
                "start_time_minutes_thu",
                "start_time_minutes_fri",
                "start_time_minutes_sat",
                "start_time_minutes_sun",
                "end_time_minutes_mon",
                "end_time_minutes_tue",
                "end_time_minutes_wed",
                "end_time_minutes_thu",
                "end_time_minutes_fri",
                "end_time_minutes_sat",
                "end_time_minutes_sun",
                "workday_minutes_mon",
                "workday_minutes_tue",
                "workday_minutes_wed",
                "workday_minutes_thu",
                "workday_minutes_fri",
                "workday_minutes_sat",
                "workday_minutes_sun",


];
const mandatoryFields = ['firstname', 'lastname'];


class clsEmployee extends clsModel {

    id_department         = null;
    id_relation           = null;
    id_jobtitle           = null;
    _empl_gen_hourlist     = null;
    _empl_is_plannable     = null;
    start_time_minutes    = null;
    end_time_minutes      = null;
    empl_workweek_minutes = null;
    firstname             = null;
    lastname              = null;
    birthday              = null;
    email                 = null;
    mobile                = null;
    bsn                   = null;
    adr_street            = null;
    adr_street_number     = null;
    adr_zipcode           = null;
    adr_city              = null;
    country_code          = null;
    tariffs               = null;
    can_app_login         = null;
    can_app_hours           = null;
    can_app_workorders      = null;
    can_app_workorders_create = null;
    workorders_create_for = null;
    workorders_employees = null; 
    hours_manage_employees  = null;
    hours_employees         = null;
    acceptedUser            = null;
    invitedUser             = null;

    start_time_minutes_mon = null;
    start_time_minutes_tue = null;
    start_time_minutes_wed = null;
    start_time_minutes_thu = null;
    start_time_minutes_fri = null;
    start_time_minutes_sat = null;
    start_time_minutes_sun = null;
    end_time_minutes_mon = null;
    end_time_minutes_tue = null;
    end_time_minutes_wed = null;
    end_time_minutes_thu = null;
    end_time_minutes_fri = null;
    end_time_minutes_sat = null;
    end_time_minutes_sun = null;
    workday_minutes_mon = null;
    workday_minutes_tue = null;
    workday_minutes_wed = null;
    workday_minutes_thu = null;
    workday_minutes_fri = null;
    workday_minutes_sat = null;
    workday_minutes_sun = null;


    // Boolean fields
    get empl_gen_hourlist()       { return this.bool(this._empl_gen_hourlist);  }
    set empl_gen_hourlist(value)  { this._empl_gen_hourlist = this.bool(value); }
    get empl_is_plannable()       { return this.bool(this._empl_is_plannable);  }
    set empl_is_plannable(value)  { this._empl_is_plannable = this.bool(value); }

    get modelRep() {
        return string.concat(' ', this.firstname, this.lastname);
    }

    /**
     * Upate one specific tariff data.
     * @param {} tariff 
     */
    updateTariff(tariff) {
        var tar = this.tariffs.find( (t) =>t.id_tariff == tariff.id_tariff && t.id_employee == tariff.id_employee);
        if (tar) {
            for(var key in tariff) {
                tar[key] = tariff[key];
            }
        }
    }

    get gs_start_time_minutes_mon()  { return this.start_time_minutes_mon; }
    get gs_start_time_minutes_tue()  { return this.start_time_minutes_tue; }
    get gs_start_time_minutes_wed()  { return this.start_time_minutes_wed; }
    get gs_start_time_minutes_thu()  { return this.start_time_minutes_thu; }
    get gs_start_time_minutes_fri()  { return this.start_time_minutes_fri; }
    get gs_start_time_minutes_sat()  { return this.start_time_minutes_sat; }
    get gs_start_time_minutes_sun()  { return this.start_time_minutes_sun; }
    get gs_end_time_minutes_mon()    { return this.end_time_minutes_mon; }
    get gs_end_time_minutes_tue()    { return this.end_time_minutes_tue; }
    get gs_end_time_minutes_wed()    { return this.end_time_minutes_wed; }
    get gs_end_time_minutes_thu()    { return this.end_time_minutes_thu; }
    get gs_end_time_minutes_fri()    { return this.end_time_minutes_fri; }
    get gs_end_time_minutes_sat()    { return this.end_time_minutes_sat; }
    get gs_end_time_minutes_sun()    { return this.end_time_minutes_sun; }

    set gs_start_time_minutes_mon(v) { this.start_time_minutes_mon = v; this.calcHoursMon(); }
    set gs_start_time_minutes_tue(v) { this.start_time_minutes_tue = v; this.calcHoursTue(); }
    set gs_start_time_minutes_wed(v) { this.start_time_minutes_wed = v; this.calcHoursWed(); }
    set gs_start_time_minutes_thu(v) { this.start_time_minutes_thu = v; this.calcHoursThu(); }
    set gs_start_time_minutes_fri(v) { this.start_time_minutes_fri = v; this.calcHoursFri(); }
    set gs_start_time_minutes_sat(v) { this.start_time_minutes_sat = v; this.calcHoursSat(); }
    set gs_start_time_minutes_sun(v) { this.start_time_minutes_sun = v; this.calcHoursSun(); }
    set gs_end_time_minutes_mon(v)   { this.end_time_minutes_mon = v; this.calcHoursMon(); }
    set gs_end_time_minutes_tue(v)   { this.end_time_minutes_tue = v; this.calcHoursTue(); }
    set gs_end_time_minutes_wed(v)   { this.end_time_minutes_wed = v; this.calcHoursWed(); }
    set gs_end_time_minutes_thu(v)   { this.end_time_minutes_thu = v; this.calcHoursThu(); }
    set gs_end_time_minutes_fri(v)   { this.end_time_minutes_fri = v; this.calcHoursFri(); }
    set gs_end_time_minutes_sat(v)   { this.end_time_minutes_sat = v; this.calcHoursSat(); }
    set gs_end_time_minutes_sun(v)   { this.end_time_minutes_sun = v; this.calcHoursSun(); }

    calcHoursMon() { 
        if (this.end_time_minutes_mon && this.start_time_minutes_mon) { 
            this.workday_minutes_mon = this.end_time_minutes_mon - this.start_time_minutes_mon; 
        } 
    }
    calcHoursTue() { if (this.end_time_minutes_tue && this.start_time_minutes_tue) { this.workday_minutes_tue = this.end_time_minutes_tue - this.start_time_minutes_tue; } }
    calcHoursWed() { if (this.end_time_minutes_wed && this.start_time_minutes_wed) { this.workday_minutes_wed = this.end_time_minutes_wed - this.start_time_minutes_wed; } }
    calcHoursThu() { if (this.end_time_minutes_thu && this.start_time_minutes_thu) { this.workday_minutes_thu = this.end_time_minutes_thu - this.start_time_minutes_thu; } }
    calcHoursFri() { if (this.end_time_minutes_fri && this.start_time_minutes_fri) { this.workday_minutes_fri = this.end_time_minutes_fri - this.start_time_minutes_fri; } }
    calcHoursSat() { if (this.end_time_minutes_sat && this.start_time_minutes_sat) { this.workday_minutes_sat = this.end_time_minutes_sat - this.start_time_minutes_sat; } }
    calcHoursSun() { if (this.end_time_minutes_sun && this.start_time_minutes_sun) { this.workday_minutes_sun = this.end_time_minutes_sun - this.start_time_minutes_sun; } }

    get workday_minutes_total() {
        return (this.workday_minutes_mon || 0) + 
               (this.workday_minutes_tue || 0) + 
               (this.workday_minutes_wed || 0) + 
               (this.workday_minutes_thu || 0) + 
               (this.workday_minutes_fri || 0) + 
               (this.workday_minutes_sat || 0) + 
               (this.workday_minutes_sun || 0);
    }

    /**
     * Load defaults for new frm the server.
     * 
     * @param {} defaults 
     * @returns 
     */
    async doCreate(defaults) {
        defaults = defaults || {};
        var result = await api.loadNew();
        return await super.doCreate(result.data);
    }

    /**
     * Update the app access info details.
     * @param {*} data 
     */
    updateAppAccessInfo(data) {
        data = data || {};
        this.can_app_login         = data.can_app_login;
        this.can_app_hours         = data.can_app_hours;
        this.can_app_workorders    = data.can_app_workorders;
        this.can_app_workorders_create = data.can_app_workorders_create; 

        this.workorders_create_for = data.workorders_create_for; 
        this.workorders_employees = data.workorders_employees; 

        this.hours_manage_employees = data.hours_manage_employees;
        this.hours_employees       = data.hours_employees;
        this.invitedUser           = data.invitedUser;
        this.acceptedUser          = data.acceptedUser; 
    }

    /**
     * Invite the given user to be connected with this employee
     * The given email could be the employee email or a different one, it is not up to us.
     * 
     * @param {} email
     * @returns 
     */
    async inviteUser(email, name) {
        this.isLoading = true;
        try {
            var result = await api.inviteUser(this.id, email, name);
            this.updateAppAccessInfo(result.data);
        }finally {            
            this.isLoading = false;
        }
    }
    async resendInvitation() {
        this.isLoading = true;
        try {
            var result = await api.resendInvitation(this.id);
            this.updateAppAccessInfo(result.data);

        }finally {
            this.isLoading = false;
        }
    }

    async removeInvitation() {
        this.isLoading = true;
        try {
            var result = await api.removeInvitation(this.id);
            this.updateAppAccessInfo(result.data);
        }finally {
            this.isLoading = false;
        }
    }
    async removeUser(email, name) {
        this.isLoading = true;
        try {
            var result = await api.removeUser(this.id);
            this.updateAppAccessInfo(result.data);
        }finally {
            this.isLoading = false;
        }
    }

    fill(data) {
        data = data ||{};
        data.start_time_minutes    = data.start_time_minutes    || 0;
        data.end_time_minutes      = data.end_time_minutes      || 0;
        data.empl_workweek_minutes = data.empl_workweek_minutes || 0;        
        data.country_code          = data.country_code          || "NL";
        data.can_app_hours         = !!data.can_app_hours;
        data.can_app_workorders    = !!data.can_app_workorders;

        data.can_app_workorders_create = !!data.can_app_workorders_create; 
        data.workorders_create_for = data.workorders_create_for || 'own'; 
        data.workorders_employees = data.workorders_employees || [];  


        data.can_app_login         = !!data.can_app_login;
        data.hours_manage_employees = data.hours_manage_employees || "own";
        data.hours_employees        = data.hours_employees ||  [];

        let result = super.fill(data);
        this.tariffs = data.tariffs;
        return result;
    }
    
    constructor() {
        super({
          api: api,   
          modelName: modelName, 
          mandatoryFields: mandatoryFields,
          id_optimit_type: id_optimit_type, 

          fillable: fields
        })
    } 
        
 }
 export default fnCreate(clsEmployee , 'clsEmployee');
